// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 343 ? "6edf0643" : chunkId) + "." + {"343":"741f68fc468bda51","6735":"a3eb23c166e5ee5a"}[chunkId] + ".js";
};